export default __webpack_public_path__ + "static/africa-icon-9def0eb2eecd27fe4ba707c0817f6667.svg";